var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.99658C13.8954 4.99658 13 5.89201 13 6.99658V16.9966C13 19.2057 11.2091 20.9966 9 20.9966C6.79086 20.9966 5 19.2057 5 16.9966V14.9966H7V16.9966C7 18.1012 7.89543 18.9966 9 18.9966C10.1046 18.9966 11 18.1012 11 16.9966V6.99658C11 4.78744 12.7909 2.99658 15 2.99658C17.2091 2.99658 19 4.78744 19 6.99658V10.1226C20.7252 10.5666 22 12.1327 22 13.9966C22 16.2057 20.2091 17.9966 18 17.9966C15.7909 17.9966 14 16.2057 14 13.9966C14 12.1327 15.2748 10.5666 17 10.1226V6.99658C17 5.89201 16.1046 4.99658 15 4.99658ZM6 7.99658C4.89543 7.99658 4 8.89201 4 9.99658C4 11.1012 4.89543 11.9966 6 11.9966C7.10457 11.9966 8 11.1012 8 9.99658C8 8.89201 7.10457 7.99658 6 7.99658ZM2 9.99658C2 7.78744 3.79086 5.99658 6 5.99658C8.20914 5.99658 10 7.78744 10 9.99658C10 12.2057 8.20914 13.9966 6 13.9966C3.79086 13.9966 2 12.2057 2 9.99658ZM16 13.9966C16 12.892 16.8954 11.9966 18 11.9966C19.1046 11.9966 20 12.892 20 13.9966C20 15.1012 19.1046 15.9966 18 15.9966C16.8954 15.9966 16 15.1012 16 13.9966Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.7a442964034c492bb0dcfedf6175ce33.svg";
export { ForwardRef as ReactComponent };